import DateField from "@/components/DateField";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const dateColumns = (columns) => columns.filter((c) => c.type === "date" || /date|\bpd\b|paid/i.test(c.name));

export default function DateFilter({ columns, value, onChange, extra = [] }) {
  const auto = dateColumns(columns);
  const cols = [...auto, ...columns.filter((c) => !auto.includes(c) && (extra.includes(c.name) || c.name === value.field))];
  if (!cols.length) return null;
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <div className="flex flex-wrap items-end gap-2" data-testid="table-date-filter">
      <div className="space-y-1">
        <p className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">Date filter</p>
        <Select value={value.field || "none"} onValueChange={(v) => onChange({ field: v === "none" ? "" : v, from: "", to: "" })}>
          <SelectTrigger className="w-44" data-testid="date-filter-field-select"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-card">
            <SelectItem value="none" data-testid="date-filter-none">No date filter</SelectItem>
            {cols.map((c) => <SelectItem key={c.name} value={c.name} data-testid={`date-filter-field-${c.name.replace(/\s+/g, "-")}`}>{c.name}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      {value.field && (
        <>
          <div className="space-y-1 w-40"><p className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">From</p>
            <DateField id="date-filter-from" value={value.from} onChange={(v) => set("from", v)} /></div>
          <div className="space-y-1 w-40"><p className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">To</p>
            <DateField id="date-filter-to" value={value.to} onChange={(v) => set("to", v)} /></div>
          <Button variant="ghost" onClick={() => onChange({ field: "", from: "", to: "" })} data-testid="date-filter-clear">Clear</Button>
          <p className="text-xs text-muted-foreground pb-2">{value.from || value.to ? "" : `Showing records with a valid date in ${value.field}`}</p>
        </>
      )}
    </div>
  );
}
